import { createContext, useContext } from 'react';

/*
 * Everything that differs between the two kinds of mail the Baukasten edits:
 * marketing mails (full documents with a mandatory unsubscribe footer) and
 * transactional mail templates (content fragments inside the branded shell).
 *
 * variables         personalization tokens offered by the pickers
 * variableHint      short explanation shown next to the pickers
 * uploadAsset       ({ fileName, contentType, content }) => { assetId, url }
 * listAssets        ({ search }) => [{ assetId, fileName, size, url, createdAt }]
 * deleteAsset       (assetId, { force }) => void
 * renderPreview     doc => { html, subject, linkCheck } rendered server-side
 * showFooterBlock   render the mandatory footer area at the bottom of the canvas
 * showMessageStyle  offer the "Nachrichtenstil" tab
 * showFallbacks     offer the personalization fallbacks in the style tab
 * savedElements     { get, create, remove } enables the "Meine Elemente" tab
 */
const defaultMailEditorConfig = {
  variables: [],
  variableHint: '',
  uploadAsset: null,
  listAssets: null,
  deleteAsset: null,
  renderPreview: null,
  showFooterBlock: false,
  showMessageStyle: true,
  showFallbacks: false,
  savedElements: null,
};

const MailEditorConfigContext = createContext(defaultMailEditorConfig);

export const MailEditorConfigProvider = ({ config, children }) => (
  <MailEditorConfigContext.Provider value={{ ...defaultMailEditorConfig, ...config }}>
    {children}
  </MailEditorConfigContext.Provider>
);

export const useMailEditorConfig = () => useContext(MailEditorConfigContext);

export default MailEditorConfigContext;
